import React, { SVGProps } from 'react'
export const FifthActiveRightSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="36"
    viewBox="0 0 16 36"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M0 35c7.839-2.151 16.68-7.948 15.959-20.695C15.484 5.902 8.083 2.413 0 1v34Z"
    />
  </svg>
)
